import { READY_MODULE_TEST_MODES } from "../constants"

export default function shouldSkipReadyModule(mode){
    if(mode === READY_MODULE_TEST_MODES.SKIP) return true
    return false
}